export const CCP_PRODUCT_ID = 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f';

export const HAMS_PRODUCT_ID = 'jira-software.ondemand';

export const PRODUCT_NAME = 'Jira';
